
import axiosPost from "./axiosPost";

export const SFHotelEmpleadoUpd = async (
    params = {},
    credentials
) => {
    const body = {
        service: "SFHotelEmpleadoUpd",
        params: {
            msuAdicionalId: params?.msuAdicionalId,
            rolCod: params?.rolCod,
            msuAdicionalVersion: params?.msuAdicionalVersion
        },
    };

    const result = await axiosPost(body, credentials);
    return result;
};
